import {
    listSelector,
    parameterisedListSelector
} from "../query-facade";
import { createSelector } from "reselect";
import { BaseObjectQueryFactory } from "../base-object/base-object.query-factory";
import { AccountObject } from "./account-object.model";
import { BaseObjectFilters } from "../../store/bootstrap";
import { VasState } from "../../store/store-type";
import { Account } from "../account/account.model";

export class AccountObjectQueryFactory<T extends AccountObject, F extends BaseObjectFilters> extends BaseObjectQueryFactory<T, F> {

    get byAccount(): parameterisedListSelector<T> {
        return (accountId: string) => createSelector(this.items,
            items => items.filter(item => item.account === accountId)
        );
    }

    get byActiveAccount(): listSelector<T> {
        return createSelector(this.items, this.selectedAccountId, (items, accountId) => {
            if (!accountId) return [];
            items = items.filter(item => item.account === accountId);
            return items;
        });
    }

    protected selectedAccountId(state: VasState): string {
        return state.account.selected;
    }

    protected selectedAccount(state: VasState): Account {
        return state.account.entities[state.account.selected];
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account-object/account-object.query-factory.ts